export default {
  dishName: 'Patiekalo Pavadinimas',
  count: 'Kiekis',
  noProvidersHeader: 'Tiekėjų nerasta!',
  noProvidersBody: 'Pasirinktomis dienomis tiekėjų nerasta.',
  total: 'Suma',
  confirmPayment: 'Patvirtinti Apmokėjimą',
  undoPayment: 'Anuliuoti Apmokėjimą',
  paidCheckboxLabel: 'Tiekėjui apmokėta',
  paidStatusChangedBy: 'Mokėjimo statusą pakeitė:',
  markProviderPaid: 'Ar tikrai norite apmokėti {total} € tiekėjui „{providerName}“ už {date}?',
  markProviderNotPaid: 'Ar tikrai norite anuliuoti {total} € apmokėjimą tiekėjui „{providerName}“ už {date}?',
  paidCheckBoxTooltip: 'Tiekėjo apmokėjimo statusas negali būti pakeistas, jei jo užsakymo laikas dar nepasibaigęs.',
  includeFreeOfCharge: 'Įtraukti nemokamas dienas',
  date: 'Data',
  markAllDaysAsPaid: 'Pažymėti visas dienas kaip apmokėtas',
  markAllDaysAsPaidAllPaidTooltip: 'Visos dienos jau pažymėtos kaip apmokėtos',
  markAllDaysAsPaidStillOrderingTooltip: 'Užsakymai vis dar galimi kai kurių dienų tiekėjam.',
  freeOfChargeTooltip: 'Nemokamos dienos negali būti apmokėtos',
  zeroCostTooltip: '0 € suma negali būti apmokėta',
};
